import { render } from "./globalAppMessage.vue?vue&type=template&id=2f9dea65"
import script from "./globalAppMessage.vue?vue&type=script&lang=js"
export * from "./globalAppMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__